import { filter } from 'rxjs/operators';
import { LoginEvents, LoginEventType } from './../../enum/tracking/login-events.enum';
import { UsersEffects } from './../../state-management/users/users.effects';
import { UsersAction } from './../../state-management/users/users.actions';
import { Actions, ofType } from '@ngrx/effects';
import { DialogsService } from './../../services/dialogs.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DialogPanelComponentContent } from './../../models/dialogs/DialogPanelComponentContent';
import { LayerService } from './../../services/LayerService';
import { Component, ElementRef, Inject, OnDestroy, OnInit, Input, Optional, SecurityContext } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { AppState } from '../../interfaces/app-state.interface';
import { Store } from '@ngrx/store';
import { Observable, Subscription } from 'rxjs';
import { FormsUtils } from '../../resources/forms.utils';
import { SettingsService } from '../../services/settings/settings.service';
import { AuthorizationWraperService } from '../../services/authorization-wraper/authorization.wraper.service';
import { AuthorizationResultPayload } from '../../models/authorization/authorization-result-payload.model';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { RoutesTable } from '../../resources/routes-table.model';
import { AuthorizationResult } from '../../enum/authorization-result.enum';
import { AuthorizationScenario } from '../../enum/authorization-scenario.enum';
import { AutoUnsubscribe } from 'ngx-auto-unsubscribe';
import { Token } from '../../models/authentication/token.model';
import { TokenType } from '../../enum/token-type.enum';
import { TokenCategory } from '../../enum/token-category.enum';
import { UserManagerService } from '../../services/users/user-manager.service';
import { HubAuthorizationComponent } from '../hub-authorization/hub-authorization.component';
import { AuthorizationAction } from '../../state-management/authorization/authorization.action';
import { AuthorizationEffects } from '../../state-management/authorization/authorization.effects';
import { TrackingActions } from '../../state-management/tracking/tracking.action';
import { dispatchTrackEvent } from '../../helpers/metrics/dispatch-track-event';
import { TrackEventType } from '../../enum/event-types';
import { StorageService } from '../../../shared/services/storage.service';
import { ALLOW_EMAIL_COOKIE } from '../../../shared/constants/cookies';
import { CaptchaService } from '../../../shared/services/captcha/captcha.service';
import { FeatureFlagService } from '../../services/feature-flag/feature-flag.service';
import { ActionEventsEnum } from '../../enum/tracking/action-events.enum';
import { environment } from '../../../src/environments/environment';


const SKIP_CAPTCHA_PARAM_NAME = '_sc';

@AutoUnsubscribe()
@Component({
    selector: 'hub-login',
    templateUrl: './hub-login.component.html',
    styleUrls: ['./hub-login.component.scss'],
})
export class HubLoginComponent extends DialogPanelComponentContent implements OnDestroy, OnInit {
    @Input() public standaloneMode: boolean;


    public loginForm: FormGroup;
    public authentication$: Observable<any>;
    public showAccountSelector: boolean;

    public loginCopy: string;
    public recaptcha: any = null;
    public registerUrl: string;

    public queryParams: ParamMap;

    private sessionId: string;

    private window: any;
    private external: boolean = false;
    private isTrustedDevice: boolean = false;
    private copyParam: string;
    private authorizationPanel: MatDialogRef<HubAuthorizationComponent>;
    private authenticationPending: boolean;
    private authenticationFailedCount: number;
    private queryParamsSubscription: Subscription;
    private tokenRequiredSubscription: Subscription;
    private authenticationSubscription: Subscription;
    private requestTokenMonthlySubscription: Subscription;
    private sendUnlockEmailAccountSubscription: Subscription;
    private successfulAuthenticationSubscription: Subscription;
    private loginRiskBlockedSubscription: Subscription;
    private sessionIdSubscription$: Subscription;
    public showSantanderAuth: boolean;
    

    constructor(
        @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
        public layerService: LayerService,
        public toastrService: ToastrService,
        public FB: FormBuilder,
        public elementRef: ElementRef,
        public dialogRef: MatDialogRef<HubLoginComponent>,
        public dialogsService: DialogsService,
        private store: Store<AppState>,
        private actions$: Actions,
        private usersEffects: UsersEffects,
        private authorizationEffects: AuthorizationEffects,
        private formsUtil: FormsUtils,
        private settingsService: SettingsService,
        private authorizationWraperService: AuthorizationWraperService,
        private router: Router,
        private userManagerService: UserManagerService,
        private route: ActivatedRoute,
        private sanitizer: DomSanitizer,
        private captchaService: CaptchaService,
        
        private featureFlagService: FeatureFlagService
    ) {
        super(elementRef, true);

        // Adiciona ao body a classe que identifica que a janela d elogin está aberta
        $('body')
            .addClass('hub-login-opened');

        this.window = window;
        this.registerUrl = this.settingsService.getConfigurationKeyValue('rau');

        this.featureFlagService.get().subscribe(featureFlags => {
            this.showSantanderAuth = featureFlags.enableLoginWithSantander;
        });

        this.store.dispatch({ type: UsersAction.resetErrorData });

        // Streams
        this.authentication$ = this.store.select((state) => state.authentication);
        this.authentication$.subscribe((authentication) => {
            this.authenticationFailedCount = authentication.authenticationFailedCount;
            this.authenticationPending = authentication.pending;

            this.sessionId = authentication.sessionID;
        });

        

        // Formulário
        this.loginForm = this.FB.group({
            username: ['', Validators.required],
            password: ['', Validators.required],
            captchaToken: '',
            captchaSiteKey: '',
            cblcAccountCode: null,
        });

        this.loginForm.get('username').valueChanges
            .subscribe((value) => {
                this.loginForm.get('username')
                    .setValue(
                        ` ${value}`.trim(),
                        {
                            onlySelf: true,
                            emitEvent: false,
                        },
                    );
            });

        // Monitora a ocorrência de erros durante a autenticação
        this.authenticationSubscription = this.actions$
            .pipe(ofType(UsersAction.loginDenied))
            .subscribe(() => {
                // Verifica o número de tentativas falhas e determina se deve aparecer sujestão de troca de senha
                this.askUserAboutUpdatePassword(this.authenticationFailedCount);


                if (this.authorizationPanel) {
                    this.authorizationPanel.componentInstance.reset();
                    this.authorizationPanel.componentInstance.setTokenAsInvalid();
                }
            });

        // Tratamento para o token not found abrir a tela de autenticação (token) quando o erro ocorrer na tela de login
        this.actions$
            .pipe(ofType(UsersAction.tokenError))
            .subscribe(() => {

                // Remove o token de 30 dias
                this.userManagerService.destroyRememberToken();

                // Caso o painel de token esteja aberto, mostra o erro para o usuário, caso contrário realiza nova chamada de login
                if (this.authorizationPanel) {
                    this.authorizationPanel.componentInstance.reset();
                    this.authorizationPanel.componentInstance.setTokenAsInvalid();
                } else {
                    this.authenticate();
                }
            });

        // Autentição bem sucedida
        this.successfulAuthenticationSubscription = this.actions$
            .pipe(ofType(UsersAction.loginSuccess))
            .subscribe(() => {

                if (this.authorizationPanel && this.authorizationPanel.componentInstance) {
                    this.authorizationPanel.componentInstance.setTokenAsValid();
                }
                this.dispatchTrackEevent(LoginEventType.Success, LoginEvents.usuarioLogado);
                // Se o cliente se autenticou e deseja que este dispositivo seja lembrado
                // deve-se requisitar um token e salva-lo em cookie.

                this.store.dispatch({
                    type: TrackingActions.trackEvents,
                    payload: {
                        type: 'Login Realized',
                        events: {
                            'Product Area Origin': 'Login',
                            'Authentication Method': 'Senha',
                            'Scenario': 'Não logado Santander',
                            'Time Responsável': 'Soho',
                        },
                    },
                });

                this.dispose();

                if (this.isTrustedDevice) {
                    this.store.dispatch({ type: AuthorizationAction.requestTokenMonthly });
                } else {
                    this.RedirectToLoggedHomeAfterLogin();
                }

            });

        // Análise de risco bloqueou — navega o painel de autorização
        this.loginRiskBlockedSubscription = this.actions$
            .pipe(ofType(UsersAction.loginRiskBlocked))
            .subscribe(() => {
                // Dispara evento de tracking
                this.store.dispatch({
                    type: TrackingActions.trackEvents,
                    payload: {
                        type: ActionEventsEnum.MODAL_OPENED,
                        events: {
                            'Product Area Origin': 'Login',
                            'Scenario': '3º fator de autenticação',
                            'Step': 'Acesso indisponível',
                            'Status': 'Não autenticado',
                            'Text': 'Acesso disponível apenas pelo app',
                            'Time Responsável': 'Soho',
                        },
                    },
                });

                const blockedPanel = this.openAuthorizationPanel(AuthorizationScenario.Login);
                blockedPanel.componentInstance.navigateToBlocked();
            });

        // Requisição de token de 30 dias bem sucedida.
        const requestTokenMonthlySubscription = this.actions$
            .pipe(ofType(AuthorizationAction.requestTokenMonthlySuccess))
            .subscribe((action: any) => {

                // Salva token de 30 dias nos cookies do dispositivo
                if (action.payload && action.payload.token) {
                    // Deleta cookie antigo se existir
                    this.userManagerService.destroyRememberToken();

                    // Salva o novo cookie
                    this.userManagerService.saveUserRememberToken(action.payload.token);

                    requestTokenMonthlySubscription.unsubscribe();
                    this.RedirectToLoggedHomeAfterLogin();
                }
            });

        // Segundo fator de autenticação necessário
        this.tokenRequiredSubscription = this.actions$
            .pipe(ofType(UsersAction.tokenRequired))
            .subscribe(async (action: any) => {

                // Verifica se existe um token salvo para este dispositivo
                // Se existir, este token será usado ao invés de solicitar ao cleinte um novo
                const cookieToken = this.userManagerService.getUserRememberToken();

                if (cookieToken) {

                    this.store.dispatch({
                        type: UsersAction.login,
                        payload: {
                            data: {
                                username: this.loginForm.value.username,
                                password: this.loginForm.value.password,
                                cblcAccountCode: this.loginForm.value.cblcAccountCode,
                                captchaToken: this.loginForm.controls.captchaToken.value,
                                captchaSiteKey: this.loginForm.controls.captchaSiteKey.value,
                            },
                            token: new Token(cookieToken, TokenType.Time, TokenCategory.Monthly),
                        },
                    });

                } else if (!this.authorizationPanel) {

                    this.store.dispatch({
                        type: UsersAction.loginAttempt,
                        payload: {
                            lastPhoneNumbers: action.payload.LastPhoneNumbers,
                            fewEmailChar: action.payload.FewEmailChar,
                            hasDevice: action.payload.UserHasDevice,
                            allowEmail: action.payload.AllowEmail,
                            userFirstName: action.payload.UserFirstName,
                            username: this.loginForm.controls.username.value,
                            password: this.loginForm.controls.password.value,
                        },
                    });

                    // Desabilita o formulário de login (hack contra autofill do navegador) — encapsulado em openAuthorizationPanel para garantir pareamento com o enable() do afterClosed.
                    this.openAuthorizationPanel(AuthorizationScenario.Login, true, true);

                    if (action.payload.AllowEmail) {
                        this.authorizationPanel.componentInstance.setAcceptEmail(true);
                    }

                    this.authorizationPanel.componentInstance.onTokenAvaliable.subscribe((result: AuthorizationResultPayload) => {
                        this.subscribePayload(result);
                        // Verifica se o cliente deseja que seu dispositivo seja lembrado
                        this.isTrustedDevice = result.trustDevice;

                        if (action.payload.AllowEmail) {
                            StorageService.setCookie(ALLOW_EMAIL_COOKIE, 'true');
                        }

                        this.store.dispatch({
                            type: UsersAction.login,
                            payload: {
                                data: {
                                    username: this.loginForm.value.username,
                                    password: this.loginForm.value.password,
                                    cblcAccountCode: this.loginForm.value.cblcAccountCode,
                                    trustDevice: result.trustDevice,
                                    captchaToken: this.loginForm.controls.captchaToken.value,
                                    captchaSiteKey: this.loginForm.controls.captchaSiteKey.value,
                                },
                                token: result.token,
                            },
                        });

                    });

                    this.authorizationPanel.componentInstance.onProcessEnd.subscribe((result) => {
                        this.subscribeDispose(result);
                    });

                    this.authorizationPanel.componentInstance.onInvalidToken
                        .pipe(filter((isInvalid) => isInvalid))
                        .subscribe(() => {
                            this.loadCaptcha();
                            this.dispatchTrackEevent(LoginEventType.Error, LoginEvents.tokenInvalido);
                        });

                    this.authorizationPanel.componentInstance.onResendToken
                        .pipe(filter((isReesend) => isReesend))
                        .subscribe(() => {
                            this.dispatchTrackEevent(LoginEventType.Error, LoginEvents.tokenReenviado);
                        });

                }

            });

        // Necessário selecionar uma das contas. Exibir seletor de contas
        this.actions$.pipe(ofType(UsersAction.accountSelectRequired)).subscribe(() => this.showAccountSelector = true);

        /** Escuta pelo envio de e-mail para desbloquear conta */
        this.sendUnlockEmailAccountSubscription = this.actions$
            .pipe(ofType(UsersAction.requestUnlockAccountEmailSuccess))
            .subscribe(() => {
                this.dialogsService.showReceipt(
                    'Solicitação enviada com sucesso',
                    'Enviamos um e-mail para que você desbloqueie a sua conta.',
                    'Fechar',
                    '/',
                    '/',
                );

                this.dispose();
            });

        this.external = this.settingsService
            .getConfigurationKeyValue('rau')
            .match(new RegExp(this.window.location.origin, 'i'));

        this.queryParamsSubscription = this.route.queryParamMap.subscribe(queryParams => this.queryParams = queryParams);
    }

    private subscribeDispose(result: any) {
        if (result === AuthorizationResult.Aborted) {
            this.dispose();
        }
    }

    private openAuthorizationPanel(scenario: AuthorizationScenario, hasBackdrop: boolean = true, disableLoginForm: boolean = false) {
        if (this.authorizationPanel) {
            return this.authorizationPanel;
        }

        if (disableLoginForm) {
            this.loginForm.disable();
        }

        this.authorizationPanel = this.authorizationWraperService
            .requestUserAuthorization(scenario, hasBackdrop);

        this.authorizationPanel.afterClosed().subscribe(() => {
            this.authorizationPanel = null;
            this.loginForm.enable();
        });

        return this.authorizationPanel;
    }
    private subscribePayload(result: AuthorizationResultPayload) {
        // Verifica se o cliente deseja que seu dispositivo seja lembrado
        this.isTrustedDevice = result.trustDevice;
        this.store.dispatch({
            type: UsersAction.login,
            payload: {
                data: {
                    ...this.loginForm.value,
                    trustDevice: result.trustDevice,
                },
                token: result.token,
            },
        });
    }

    public ngOnInit() {
        this.copyParam = this.route.snapshot.params['flavor'];
        this.loginCopy = this.getLoginCopy(this.copyParam);
    }

    /**
     * Metodo chamado no fim do ciclo de vida do componente
     */
    public ngOnDestroy() {
        // Remove do body a classe que identifica que a janela está aberta
        $('body')
            .removeClass('hub-login-opened');
    }

    /**
     * Cancela a autenticação do usuário
     */
    public cancelLogin() {
        if (!this.authenticationPending) this.dispose();
    }

    /**
     * Gera um novo captcha
     */
    private async loadCaptcha() {
        const captcha = await this.captchaService.getLoginCaptcha();

        this.loginForm.controls.captchaToken.setValue(captcha.token);
        this.loginForm.controls.captchaSiteKey.setValue(captcha.siteKey);
    }

    /**
     * Handler para submição do formuláro. Executa o recaptcha
     *
     * @param event evento de submição do formulário.
     */
    public async authenticate(event: Event = null) {
        dispatchTrackEvent({
            store: this.store,
            origin: 'Login',
            eventType: TrackEventType.UserClicked,
            element: 'Botão Entrar',
        });

        StorageService.deleteCookie(ALLOW_EMAIL_COOKIE);

        if (event) {
            event.preventDefault();
        }

        if (!this.queryParams.has(SKIP_CAPTCHA_PARAM_NAME)) {
            await this.loadCaptcha();
        }

        this.DispatchLogin();

        // Detecta tipo de username
        const username: string = this?.loginForm?.value?.username || '';
        let usernameType = '';
        if (/^\d{11}$/.test(username.replace(/\D/g, ''))) {
            usernameType = 'CPF';
        } else if (/^[A-Za-z0-9]{14}$/.test(username)) {
            usernameType = 'CNPJ';
        } else if (username.includes('@')) {
            usernameType = 'Email';
        } else {
            usernameType = 'Não identificado';
        }

        this.store.dispatch({
            type: TrackingActions.trackEvents,
            payload: {
                type: ActionEventsEnum.ELEMENT_CLICKED,
                events: {
                    'Product Area Origin': 'Login',
                    'Element': 'Botão entrar',
                    'Scenario': 'Não logado',
                    'Time Responsável': 'Soho',
                    'Username Type': usernameType,
                },
            },
        });
    }

    /**
     * Após erro de login (terceiro erro) o usuário é questionado se deseja atualizar sua senha.
     */
    public askUserAboutUpdatePassword(attempt: number) {

        this.dispatchTrackEevent(LoginEventType.Error, LoginEvents[`erroSenha${attempt}x`]);

        // Identifica acesso bloqueado
        const remainingAttempts = 5 - attempt;
        if (!remainingAttempts) {
            setTimeout(() => this.dispatchTrackEevent(LoginEventType.Error, LoginEvents.usuarioBloqueado), 1000);
            return this.showLockedAccountWarning();
        }
    }

    /**
     * Exibe modal de senha errada x vezes
     */
    public modalRemaingAttempts(remainingAttempts, attempt) {
        const textRemainingAttempts = remainingAttempts === 1 ? '1 tentativa errada' : `${remainingAttempts} tentativas erradas`;

        this.dialogsService.confirmAction(
            'Cuidado',
            `<p class='modal-text'>
                Você errou sua senha <b>${attempt} vezes.</b><br>
                Com mais ${textRemainingAttempts}, sua conta vai ser bloqueada.
            </p>
            <p class='modal-text'>
                Quer alterar sua senha?
            </p>`,
            `Alterar Senha`,
            `Voltar`,
        )
            .subscribe((result) => {
                if (result) {
                    this.router.navigateByUrl(RoutesTable.hubUrls.routes.ForgotPasswordForm.uri);
                    this.dispose();
                }
            });
    }

    private handleModalBackdropClick() {
        dispatchTrackEvent({
            store: this.store,
            origin: 'Login',
            scenario: 'Senha Bloqueada',
            element: 'Backdrop',
            eventType: TrackEventType.UserClicked,
        });
    }

    /**
     * Após o quinto erro durante a autenticação o usuário é informado do
     * bloqueio de sua conta.
     */
    public showLockedAccountWarning() {
        dispatchTrackEvent({
            store: this.store,
            origin: 'Login',
            scenario: 'Senha Bloqueada',
            eventType: TrackEventType.ModalOpened,
        });

        this.dispose();

        this.dialogsService.confirmDestructiveAction(
            'Sua senha foi bloqueada. Crie uma nova para continuar.',
            'Foram feitas muitas tentativas de login. Por segurança, sua senha atual foi bloqueada.',
            'Criar nova senha',
            'Fechar',
            undefined,
            {
                hasBackdropClick: true,
                onBackdropClick: () => this.handleModalBackdropClick(),
            },
        )
            .subscribe((result) => {
                if (result === true) {
                    dispatchTrackEvent({
                        store: this.store,
                        origin: 'Login',
                        scenario: 'Senha Bloqueada',
                        element: 'Botão Criar Nova Senha',
                        eventType: TrackEventType.UserClicked,
                    });

                    this.router.navigateByUrl('/esqueci-minha-senha');
                } else if (result === false) {
                    dispatchTrackEvent({
                        store: this.store,
                        origin: 'Login',
                        scenario: 'Senha Bloqueada',
                        element: 'Botão Fechar',
                        eventType: TrackEventType.UserClicked,
                    });
                }

                this.dialogsService.closeAll();

            });

    }

    /**
     * Dispatch Login
     */
    public DispatchLogin() {
        this.formsUtil.ValidFormBaseSync(this.loginForm, () => this.store.dispatch({
            type: UsersAction.login,
            payload: {
                data: this.loginForm.value,
            },
        }));
    }

    public handleReset() {
        return true;
    }

    /**
     * Handler para selção de conta
     *
     * @param accountId cblc code
     */
    public accountOptionSelected(accountId: string) {
        this.showAccountSelector = false;
        this.loginForm.controls.cblcAccountCode.setValue(accountId);
        this.authenticate();
    }

    private forgotPassword() {
        this.dispose();
    }

    public goToForgotPassword() {
        dispatchTrackEvent({
            store: this.store,
            origin: 'Login',
            eventType: TrackEventType.UserClicked,
            element: 'Link Esqueceu Sua Senha',
        });

        this.forgotPassword();

        this.redirect("/esqueci-minha-senha");
    }

    /**
     * Realiza a navegação da url requisitada
     */
    public redirect(url: string) {
        if (this.external) {
            window.location.href = url;
        } else {
            this.router.navigateByUrl(url);
        }
    }

    public getLoginCopy(param: string) {
        const copyTexts = {
            cadastro: `Acesse sua conta para continuar o cadastro.`,
            default: `Acesse sua conta`,
        };
        return copyTexts[param] ? copyTexts[param] : copyTexts.default;
    }

    /**
     * Finaliza o panel
     */
    private dispose() {
        if (this.authorizationPanel) this.authorizationPanel.componentInstance.end();
    }

    private navigateToRegister() {
        this.router.navigate([this.registerUrl]);
    }

    /**
     * Enviar e-mail para desbloqueio de conta
     */
    private sendUnlockAccountEmail() {
        this.store.dispatch({ type: UsersAction.requestUnlockAccountEmail });
    }

    /**
     * Controi um prefixo em base64 para o nome do cookie onde será armazenado
     * o token de lembrança de dispositivo com base no username do cliente
     *
     * Motivo: não repetir token entre clientes que usem o mesmo dispositivo
     */
    private getRememberTokenPrefix() {
        return btoa(this.loginForm.value.username.slice(0, 3))
            .replace('=', '.');
    }

    /**
     * @description
     * Disparar eventos para trackeamento do GA/GTM
     *
     * @param {LoginEventType.Error|'Sucesso'} type
     * @param {string} event
     */
    private dispatchTrackEevent(type: LoginEventType, event: LoginEvents) {
        this.store.dispatch({
            type: TrackingActions.trackLoginEvent,
            payload: { type, event },
        });
    }

    private getUrlParam(param) {
        return new URLSearchParams(window.location.search).get(param);
    }


    private isSafeRedirectUrl(url: string): boolean {
        if (!url) {
            return false
        }
        let patternToBlock = new RegExp(/[.:()]|http|www/g);

        if (url.includes("open-finance")) {
            patternToBlock = new RegExp(/[.()]|http|www/g);
        }

        if (patternToBlock.test(url)) {
            return false;
        }

        return this.sanitizer.sanitize(SecurityContext.URL, url)
            .startsWith('/');
    }

    private RedirectToLoggedHomeAfterLogin() {
        const currentUrl = window.location.href;
        const currentPath = window.location.pathname;
        const isRegisterApp = currentUrl.includes('cadastro') ||
            currentPath.startsWith('/cadastro') ||
            currentPath.startsWith('/register') ||
            currentUrl.includes('/cadastro') ||
            currentUrl.includes('/register');

        if (isRegisterApp) {
            if (this.dialogRef) {
                this.dialogRef.close();
            }
            return;
        }

        if (new RegExp('/home').test(window.location.href)) return;

        const redirectTo = this.getUrlParam('redirectTo');

        if (redirectTo && this.isSafeRedirectUrl(redirectTo)) {
            window.location.href = redirectTo;
            return;
        }

        const domain = this.settingsService.getConfigurationKeyValue('loggedHomeDomain') || '';

        window.location.href = domain + RoutesTable.hubProjectsURLS.routes.LoggedHome.uri;
    }

    public loginWithSantander() {
        this.store.dispatch({
            type: TrackingActions.trackEvents,
            payload: {
                type: ActionEventsEnum.ELEMENT_CLICKED,
                events: {
                    'Product Area Origin': 'Login',
                    'Element': 'Botão entrar com Santander',
                    'Scenario': 'Não logado',
                    'Time Responsável': 'Soho',
                },
            },
        });

        const { webapi } = this.settingsService.getConfigurationKeyValue('backend');

        const redirectTo = `${webapi}auth/authentication/authorizer/santander/login?sessionId=${this.sessionId}`;
        this.popupWindow(redirectTo, 'santander_auth', 570, 520);

        return;
    }

    private popupWindow(url: string, title: string, w: number, h: number) {
        const left = (screen.width / 2) - (w / 2);
        const top = (screen.height / 2) - (h / 2);
        return window.open(url, title, 'toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=no, resizable=no, copyhistory=no, width=' + w + ', height=' + h + ', top=' + top + ', left=' + left);
    }
}
